import { Routes } from '@angular/router';
import { rolesGuard } from '@core/auth';
import { groupResolver } from './resolvers/group.resolver';

/**
 * Routes configuration for group management functionality.
 *
 * Defines navigation structure for group CRUD operations including:
 * - Group list with breadcrumb navigation
 * - Group creation page
 * - Group edition page with group data resolution
 */
export const routes: Routes = [
	{
		path: '',
		canActivate: [rolesGuard],
		data: {
			breadcrumb: 'GROUP_LIST.BREADCRUMBS.MAIN',
			roles: ['ROLE_GROUP_READ']
		},
		children: [
			{
				path: '',
				loadComponent: () =>
					import('./components/group-list/group-list.component').then(
						(c) => c.GroupListComponent
					)
			},
			{
				path: 'add',
				canActivate: [rolesGuard],
				data: {
					breadcrumb: 'GROUP_EDITION.BREADCRUMBS.ADD',
					roles: ['ROLE_GROUP_CREATE']
				},
				loadComponent: () =>
					import('./components/group-edition/group-edition.component').then(
						(c) => c.GroupEditionComponent
					)
			},
			{
				path: ':groupId',
				canActivate: [rolesGuard],
				data: {
					breadcrumb: 'GROUP_EDITION.BREADCRUMBS.EDIT',
					roles: ['ROLE_GROUP_UPDATE']
				},
				resolve: { value: groupResolver },
				loadComponent: () =>
					import('./components/group-edition/group-edition.component').then(
						(c) => c.GroupEditionComponent
					)
			}
		]
	}
];
